import React from "react";
import { LoadingComp } from "../LoadingComp";
import "./style.scss";

const SearchBox = props => (
  <div className="search-space">
    <i className="fa fa-search"></i>
    <div className="input-box">
      <input
        id="search_value"
        type="text"
        placeholder="Where would you like to work?"
        autoComplete="off"
        onChange={props.handleSearch}
        value={props.val}
        onKeyDown={props.handleKeyDown}
        onKeyPress={props.handleKeyPress}
      />

      {!props.isLoading ? (
        <div
          className={`searched-list ${
            props.isHeader ? "header_searched_list" : ""
          }`}
          scrollwrapper="scrollwrapper"
        >
          {props.search_list && props.search_list.length > 0 ? (
            <ul>
              {props.search_list.map((list, i) => (
                <li
                  scrollindex={i}
                  key={i}
                  onClick={() =>
                    props.url(
                      list.url,
                      list.text.toLowerCase(),
                      list.text_url,
                      list.city_id,
                      list.country_id
                    )
                  }
                  className={props.cursor === i ? "active" : null}
                  dangerouslySetInnerHTML={{
                    __html:
                      "<i class=" +
                      list.type +
                      "></i>" +
                      "<span>" +
                      list.text
                        .toLowerCase()
                        .replace(
                          props.val.toLowerCase(),
                          "<b>" + props.val + "</b>"
                        ) +
                      "</span>"
                  }}
                />
              ))}
            </ul>
          ) : null}
        </div>
      ) : props.val !== "" ? (
        props.isHeader ? (
          <LoadingComp
            customStyle={{
              position: "absolute",
              top: 0,
              right: "15px",
              padding: 0,
              width: "35px"
            }}
          />
        ) : (
          <LoadingComp
            customStyle={{
              position: "absolute",
              top: 0,
              right: window.innerWidth <= 767 ? "15px" : "110px",
              padding: "10px 0",
              width: "40px"
            }}
          />
        )
      ) : null}
    </div>
    {!props.isHeader ? (
      <div className="go-btn">
        <button onClick={props.autoSelect}>
          <strong>GO</strong>
        </button>
      </div>
    ) : null}
  </div>
);

export default SearchBox;
